import React, {useCallback, useEffect, useReducer, useState} from 'react';

import {ACTIONS} from './constants';

export type ID = string | number;
export type Field = string;

export type Action =
	| {type: typeof ACTIONS.ADD_CHANGES; changes: Changes}
	| {type: typeof ACTIONS.REMOVE_CHANGES; changes: Changes}
	| {type: typeof ACTIONS.RESET; changes?: Changes}
	| {type: typeof ACTIONS.SET_COUNT; count: number};

export type Change = Field[];

export type Changes = {
	[primary: string]: Change;
};
export type State = {
	count: number;
	changes: Changes;
};

export const initialState: State = {
	changes: {},
	count: 0,
};

const reducer = (state: State, action: Action) => {
	switch (action.type) {
		case ACTIONS.SET_COUNT:
			return {
				...state,
				count: action.count,
			};
		case ACTIONS.ADD_CHANGES: {
			const currentChanges = JSON.parse(JSON.stringify(state.changes));
			for (const key in action.changes) {
				const changes = action.changes[key];
				currentChanges[key] = !currentChanges[key]
					? [...new Set([...changes])]
					: [...new Set([...currentChanges[key], ...changes])];
			}
			return {
				...state,
				changes: currentChanges,
			};
		}
		case ACTIONS.REMOVE_CHANGES: {
			const currentChanges: typeof state.changes = JSON.parse(
				JSON.stringify(state.changes),
			);
			for (const key in action.changes) {
				const changes = action.changes[key];
				if (currentChanges[key]) {
					currentChanges[key] = currentChanges[key].filter(
						(field) => !changes.includes(field),
					);
					if (!currentChanges[key].length) delete currentChanges[key];
				}
			}
			return {
				...state,
				changes: currentChanges,
			};
		}
		case ACTIONS.RESET:
			return {
				...initialState,
				changes: action.changes || initialState.changes,
			};
	}
};

export default reducer;
